
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { getImoDcsReportSummary } from "../../../../../../services/ChildReportService";
import { ROLE_TYPES } from "../../../../../../constants/roles";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Loader from "../../../../../../common/Loader/Loader";
import { CII_UNSATISFACTORY_WARNING_MESSAGES } from "../../../../../../constants/CIIUnsatisfactoryConstants";



const extractCapacityDetails = (summaryRows) => {
    const capacityDetails = {
        requiredCiiCapacity: undefined,
        attainedCiiCapacity: undefined,
    };

    (summaryRows || []).forEach((row) => {
        (row?.summaryColumns || []).forEach((column) => {
            const label = String(column?.label || "");

            const requiredMatch = label.match(
                /Required\s+CII\s*\(?\s*([\d,]+(?:\.\d+)?)/i
            );

            const withExclusionMatch = label.match(
                /Attained\s+CII\s+With\s+Exclusion\s*\(?\s*([\d,]+(?:\.\d+)?)/i
            );

            const withoutExclusionMatch = label.match(
                /Attained\s+CII\s+Without\s+Exclusion\s*\(?\s*([\d,]+(?:\.\d+)?)/i
            );

            if (requiredMatch) {
                capacityDetails.requiredCiiCapacity =
                    requiredMatch[1].replace(/,/g, "");
            }
            if (withoutExclusionMatch) {
                capacityDetails.attainedCiiCapacity =
                    withoutExclusionMatch[1].replace(/,/g, "");
            } else if (
                withExclusionMatch &&
                capacityDetails.attainedCiiCapacity === undefined
            ) {
                capacityDetails.attainedCiiCapacity =
                    withExclusionMatch[1].replace(/,/g, "");
            }
        });
    });

    return capacityDetails;
};

// Column Component
const SummaryColumn = ({
    column,
    row,
    tooltipText,
     isReportedHeader,
    hideCalculatedLabel,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const columnStyles = {
        border: column.isBordered ? "1px solid #ccc" : "none",
        textAlign: column.isRightAligned
            ? "right"
            : column.isCenterAligned
            ? "center"
            : "left",
        width: column.isFixSize ? "300px" : "180px",
        padding: "8px",
        fontWeight: column.isTitle || column.isBold ? "bold" : "normal",
        position: "relative",
    };

    const isNumber =
        column.label !== null &&
        column.label !== undefined &&
        String(column.label).trim() !== "" &&
        !isNaN(Number(column.label));

    const formattedValue =
        isNumber && column.isRightAligned
            ? Number(column.label).toFixed(3)
            : column.label;

    return (
        <td style={columnStyles}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: column.isRightAligned
                        ? "flex-end"
                        : column.isCenterAligned
                        ? "center"
                        : "flex-start",
                    gap: "6px",
                    width: "100%",
                }}
            >
                {column.isBlue && (
					<Tooltip
						title="Capacity has been changed."
						arrow
						componentsProps={{
							tooltip: {
								sx: {
									fontSize: "13px",
									backgroundColor: "#012c51 !important",
									color: "white",
								},
							},
						}}
					>
						<InfoIcon
							fontSize="small"
							style={{
								color: "#2964a8",
								cursor: "pointer",
								flexShrink: 0,
							}}
						/>
					</Tooltip>
				)}

				{column.isTitle && row?.bdnId ? (
					<Tooltip title={`BDN ID: ${row.bdnId}`} placement="bottom" arrow>
						<span>{formattedValue}</span>
					</Tooltip>
				) : (
					<span>{formattedValue}</span>
				)}

                {/* Info icon appears AFTER Calculated */}
                
{isReportedHeader  && (
					<Tooltip
						arrow
						placement="right"
						slotProps={{
							tooltip: {
								sx: {
									backgroundColor: "#ffffff",
									color: "#212529",
									fontFamily: "Roboto, sans-serif",
									boxShadow: "0px 4px 16px rgba(0,0,0,0.18)",
									borderRadius: "4px",
									padding: "0px",
									maxWidth: "none",
									width: "410px",
								},
							},
							arrow: {
								sx: {
									color: "#ffffff",
								},
							},
						}}
						title={
							<div
								style={{
									padding: "10px 14px",
									width: "100%",
									boxSizing: "border-box",
									fontFamily: "Roboto, sans-serif",
								}}
							>
								{/* Header */}
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "5px",
									}}
								>
									<span
										style={{
											fontWeight: "bold",
											fontSize: "14px",
											color: "#0b2038",
										}}
									>
										Capacity Used for CII Calculations
									</span>

									
								</div>

								{/* Description */}
								<div
									style={{
										fontSize: "12px",
										lineHeight: "1.4",
										color: "#333333",
										marginBottom: "8px",
									}}
								>
									The following capacities were used for CII calculations for the selected reporting year.
								</div>

								{/* Capacity Table */}
								<table
									style={{
										width: "100%",
										borderCollapse: "collapse",
										borderSpacing: 0,
										tableLayout: "fixed",
										fontSize: "12px",
										border: "1px solid #d0d5dc",
										marginBottom: "8px",
									}}
								>
									<thead>
										<tr style={{ backgroundColor: "#e8edf4", color: "#0b2038" }}>
											<th
												style={{
													width: "60%",
													textAlign: "left",
													padding: "6px 10px",
													borderRight: "1px solid #d0d5dc",
													borderBottom: "1px solid #d0d5dc",
													fontWeight: "bold",
												}}
											>
												Calculation
											</th>
											<th
												style={{
													width: "40%",
													textAlign: "right",
													padding: "6px 10px",
													borderBottom: "1px solid #d0d5dc",
													fontWeight: "bold",
												}}
											>
												Capacity Used
											</th>
										</tr>
									</thead>

									<tbody>
										{[
											{
                                                label: "Required CII",
                                                value: tooltipText?.requiredCiiCapacity,
                                            },
                                            {
                                                label: "Attained CII",
                                                value: tooltipText?.attainedCiiCapacity,
                                            },
										].map((item, index) => (
											<tr key={item.label}>
												<td
													style={{
														padding: "6px 10px",
														borderRight: "1px solid #d0d5dc",
														borderBottom: index < 2 ? "1px solid #d0d5dc" : "none",
														fontWeight: "bold",
														color: "#222222",
													}}
												>
													{item.label}
												</td>
												<td
													style={{
														padding: "6px 10px",
														textAlign: "right",
														borderBottom: index < 2 ? "1px solid #d0d5dc" : "none",
														color: "#333333",
													}}
												>
													{item.value ?? "-"}
												</td>
											</tr>
										))}
									</tbody>
								</table>

								{/* Footer */}
								<div
									style={{
										fontSize: "12px",
										lineHeight: "1.4",
										color: "#333333",
									}}
								>
									Capacity used may differ from the current vessel capacity shown under Vessel Details.
								</div>
							</div>
						}
					>
						<span
							style={{
								width: "16px",
								height: "16px",
								borderRadius: "50%",
								backgroundColor: "#3a68ab",
								color: "#ffffff",
								fontSize: "11px",
								fontWeight: "bold",
								fontFamily: "Arial, sans-serif",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								lineHeight: "1",
								cursor: "pointer",
								flexShrink: 0,
							}}
						>
							i
						</span>
					</Tooltip>
				)}
			</div>
		</td>
	);
};
// Row Component

const SummaryRow = ({
    row,
    rowIndex,
    tableName,
    showCalculatedTooltip,
    capacityDetails,
}) => {
   const capacityColumns = (row?.summaryColumns || []).filter((col) => {
    const label = String(col?.label || "").toLowerCase();

    return (
        label.includes("capacity considered for") ||
        (
            label.includes("required cii") &&
            label.includes("attained cii with exclusion") &&
            label.includes("attained cii without exclusion")
        )
    );
});

    const visibleColumns = (row?.summaryColumns || []).filter(
        (col) => !capacityColumns.includes(col)
    );

    const isCiiSummary =
    String(tableName || "").trim().toLowerCase() === "cii summary";

const hasCapacityData = [
    capacityDetails?.requiredCiiCapacity,
    capacityDetails?.attainedCiiCapacity,

].some(
    (value) =>
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ""
);

    return (
        <tr>
            {visibleColumns.map((column, index) => {
                const isReportedHeader =isCiiSummary &&showCalculatedTooltip && hasCapacityData && String(column?.label || "").trim().toLowerCase() === "reported";

                return (
                    <SummaryColumn
                        key={index}
                        column={column}
                        row={row}
                        isReportedHeader ={isReportedHeader }
                        tooltipText={
                            isReportedHeader  ? capacityDetails : undefined
                        }
                    />
                );
            })}
        </tr>
    );
};


// Table Component

const SummaryTable = ({ table, collapsed }) => {
    const [isCollapsed, setIsCollapsed] = useState(collapsed);

    const toggleCollapse = () => {
        setIsCollapsed((previous) => !previous);
    };

    const rows = table.summaryRows || [];
    const capacityDetails = extractCapacityDetails(rows);

    const isCiiSummary =
        String(table?.tableName || "").trim().toLowerCase() ===
        "cii summary";

    const firstCalculatedRowIndex = isCiiSummary
        ? rows.findIndex((row) =>
              (row?.summaryColumns || []).some(
                  (column) =>
                      String(column?.label || "")
                          .trim()
                          .toLowerCase() === "calculated"
              )
          )
        : -1;

    const maxColumns = Math.max(
        0,
        ...rows.map((row) => (row.summaryColumns || []).length)
    );

    const tableWidth =
        maxColumns <= 3 ? "40%" : maxColumns <= 5 ? "60%" : "90%";

    return (
        <div style={{ margin: "20px 0" }}>
            <h5
                onClick={toggleCollapse}
                style={{
                    marginLeft: "20px",
                    backgroundColor: "#012c51",
                    color: "white",
                    textTransform: "uppercase",
                    padding: "10px",
                    cursor: "pointer",
                }}
            >
                {isCollapsed ? "+" : "-"} {table.tableName}
            </h5>
            {!isCollapsed && (
                <table
                    style={{
                        width: tableWidth,
                        borderCollapse: "collapse",
                        marginLeft: "20px",
                    }}
                >
                    <tbody>
                        {table.summaryRows.map((row, index) => (
                            <React.Fragment key ={index}>
                            <SummaryRow key={index} row={row} tableName={table.tableName} showCalculatedTooltip={index === firstCalculatedRowIndex} capacityDetails={capacityDetails}/>
                            {table.tableName === "CII Summary" &&
										table.shouldShowUnsatisfactoryWarning &&
										index === 6 && (
											<tr>
												<td colSpan={maxColumns}>
													<div className="unsatifactory-warning-msg" style={{marginBottom:"-10px"}}>
														{CII_UNSATISFACTORY_WARNING_MESSAGES.REPORT_SUMMARY_UNSATISFACTORY_WARNING}
													</div>
												</td>
											</tr>
										)}
								</React.Fragment>
						    ))}
                            
                    </tbody>
                </table>
            )}
        </div>
    );
};

// Summary Tables Component
const DcsSummaryTables = ({ summaryTables }) => {
    return (
        <div>
            {summaryTables.map((table, index) => (
                <SummaryTable key={index} table={table} collapsed={index > 0} />
            ))}
        </div>
    );
};

// Main Component
const DcsSummaryView = () => {
    const { selectedReportDetails: reportDetails } = useSelector(
        (state) => state.reports,
        shallowEqual
    );
    const user = useSelector((state) => state.userInfo.userData);
    const [loading, setLoading] = useState(true);
    const [summaryTablesData, setSummaryTablesData] = useState([]);

    const isErClient = useMemo(() => {
        const roles = user?.roles ?? user?.Roles ?? [];

        if (!Array.isArray(roles)) {
            return false;
        }

        return roles.some(
            (role) =>
                String(role || "").toUpperCase().trim() ===
                ROLE_TYPES.ER_CLIENT
        );
    }, [user]);

    const summaryTables = useMemo(() => {
        if (!Array.isArray(summaryTablesData)) {
            return [];
        }

        return summaryTablesData.map((table) => {
            if (
                String(table?.tableName || "").toUpperCase().trim() !==
                "CII SUMMARY"
            ) {
                return table;
            }

            return {
                ...table,
                summaryRows: (table?.summaryRows || []).map((row) => {
                    const summaryColumns = (row?.summaryColumns || [])
                        .filter((column) => {
                            const label = String(column?.label || "")
                                .toUpperCase()
                                .trim();

                            if (!isErClient) {
                                return true;
                            }

                            return label !== "WITH CII EXCLUSION";
                        })
                        .map((column) => {
                            const label = String(column?.label || "")
                                .toUpperCase()
                                .trim();

                            if (label === "WITHOUT CII EXCLUSION") {
                                return {
                                    ...column,
                                    label: "Reported",
                                };
                            }

                            return column;
                        });

                    return {
                        ...row,
                        summaryColumns,
                    };
                }),
            };
        });
    }, [isErClient, summaryTablesData]);

    useEffect(() => {
        const fetchDcsmrvReportSummary = async () => {
            const reportMstId = reportDetails?.ReportMstId;
            if (reportMstId) {
                try {
                    const dcsReportSummaryData = await getImoDcsReportSummary(reportMstId);
                    setSummaryTablesData(dcsReportSummaryData.data.summaryTables
                    );
                } catch (error) {
                    console.error("Error fetching report summary:", error);
                } finally {
                    setLoading(false);
                }
            } else {
                console.warn("ReportMstId is missing or undefined.");
                setLoading(false);
            }
        };
        fetchDcsmrvReportSummary();
    }, [reportDetails]);

    return (
                <div>
            {loading ? (
                <div className="loader">
                    <Loader />
                </div>
            ) : (
                <DcsSummaryTables summaryTables={summaryTables} />
            )}
             </div>
    );
};

export default DcsSummaryView;